import { default as aboutcGvMViY0SnMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexhyMXUmjJA7Meta } from "/opt/buildhome/repo/pages/admin/index.vue?macro=true";
import { default as statusOjhhtDpIHoMeta } from "/opt/buildhome/repo/pages/admin/status.vue?macro=true";
import { default as _91id_93qQW7PBCtvCMeta } from "/opt/buildhome/repo/pages/admin/users/[id].vue?macro=true";
import { default as indexXtUngUp57YMeta } from "/opt/buildhome/repo/pages/admin/users/index.vue?macro=true";
import { default as api_45logsQwDTCVuK8sMeta } from "/opt/buildhome/repo/pages/api-logs.vue?macro=true";
import { default as api_45testerP2viGkoBm6Meta } from "/opt/buildhome/repo/pages/api-tester.vue?macro=true";
import { default as apimKruMht4aSMeta } from "/opt/buildhome/repo/pages/api.vue?macro=true";
import { default as authdjl0VO0QO1Meta } from "/opt/buildhome/repo/pages/auth.vue?macro=true";
import { default as billingi84s02FJFOMeta } from "/opt/buildhome/repo/pages/billing.vue?macro=true";
import { default as connect_45extensionj2UQsyuvGjMeta } from "/opt/buildhome/repo/pages/connect-extension.vue?macro=true";
import { default as contactupLWW5VsuQMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as dashboard6cxkiptQlsMeta } from "/opt/buildhome/repo/pages/dashboard.vue?macro=true";
import { default as downloaderNYzEtMQDDCMeta } from "/opt/buildhome/repo/pages/downloader.vue?macro=true";
import { default as extensionODXOSAMnqoMeta } from "/opt/buildhome/repo/pages/extension.vue?macro=true";
import { default as hardsub_45to_45subtitleWY6ahZA8QsMeta } from "/opt/buildhome/repo/pages/hardsub-to-subtitle.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as logsf8yw9QQw8vMeta } from "/opt/buildhome/repo/pages/logs.vue?macro=true";
import { default as multi_45downloaderpdH0dgAB32Meta } from "/opt/buildhome/repo/pages/multi-downloader.vue?macro=true";
import { default as plansh8hnpQWIttMeta } from "/opt/buildhome/repo/pages/plans.vue?macro=true";
import { default as playlist_45downloaderpkKNpfeVRDMeta } from "/opt/buildhome/repo/pages/playlist-downloader.vue?macro=true";
import { default as preferenceLEPtWeYBEuMeta } from "/opt/buildhome/repo/pages/preference.vue?macro=true";
import { default as privacy69l1Gm1VSzMeta } from "/opt/buildhome/repo/pages/privacy.vue?macro=true";
import { default as updateqDcvL67VWnMeta } from "/opt/buildhome/repo/pages/profile/update.vue?macro=true";
import { default as region_45checker37Fm51pL7uMeta } from "/opt/buildhome/repo/pages/region-checker.vue?macro=true";
import { default as settings4cDYwTsA31Meta } from "/opt/buildhome/repo/pages/settings.vue?macro=true";
import { default as subtitle_45summaryGIzSgGsHjdMeta } from "/opt/buildhome/repo/pages/subtitle-summary.vue?macro=true";
import { default as subtitle_45tasks78lQdUOTjbMeta } from "/opt/buildhome/repo/pages/subtitle-tasks.vue?macro=true";
import { default as subtitle_45translatornGHFcMoi8SMeta } from "/opt/buildhome/repo/pages/subtitle-translator.vue?macro=true";
import { default as termsjw1825O2ZdMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as toolsR4YN1MOTeTMeta } from "/opt/buildhome/repo/pages/tools.vue?macro=true";
import { default as usage_45historyulteczHHg0Meta } from "/opt/buildhome/repo/pages/usage-history.vue?macro=true";
import { default as video_45audio_45to_45summaryE8UlIv0wpxMeta } from "/opt/buildhome/repo/pages/video-audio-to-summary.vue?macro=true";
import { default as video_45to_45subtitle34m6JJqGE0Meta } from "/opt/buildhome/repo/pages/video-to-subtitle.vue?macro=true";
import { default as youtube_45toolslMsGhMDHp6Meta } from "/opt/buildhome/repo/pages/youtube-tools.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutcGvMViY0SnMeta || {},
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexhyMXUmjJA7Meta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/index.vue")
  },
  {
    name: "admin-status",
    path: "/admin/status",
    meta: statusOjhhtDpIHoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/status.vue")
  },
  {
    name: "admin-users-id",
    path: "/admin/users/:id()",
    meta: _91id_93qQW7PBCtvCMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/users/[id].vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: indexXtUngUp57YMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/users/index.vue")
  },
  {
    name: "api-logs",
    path: "/api-logs",
    component: () => import("/opt/buildhome/repo/pages/api-logs.vue")
  },
  {
    name: "api-tester",
    path: "/api-tester",
    component: () => import("/opt/buildhome/repo/pages/api-tester.vue")
  },
  {
    name: "api",
    path: "/api",
    component: () => import("/opt/buildhome/repo/pages/api.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: authdjl0VO0QO1Meta || {},
    component: () => import("/opt/buildhome/repo/pages/auth.vue")
  },
  {
    name: "billing",
    path: "/billing",
    component: () => import("/opt/buildhome/repo/pages/billing.vue")
  },
  {
    name: "connect-extension",
    path: "/connect-extension",
    meta: connect_45extensionj2UQsyuvGjMeta || {},
    component: () => import("/opt/buildhome/repo/pages/connect-extension.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactupLWW5VsuQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/opt/buildhome/repo/pages/dashboard.vue")
  },
  {
    name: "downloader",
    path: "/downloader",
    component: () => import("/opt/buildhome/repo/pages/downloader.vue")
  },
  {
    name: "extension",
    path: "/extension",
    meta: extensionODXOSAMnqoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/extension.vue")
  },
  {
    name: "hardsub-to-subtitle",
    path: "/hardsub-to-subtitle",
    component: () => import("/opt/buildhome/repo/pages/hardsub-to-subtitle.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexniDiYCWjuTMeta || {},
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "logs",
    path: "/logs",
    component: () => import("/opt/buildhome/repo/pages/logs.vue")
  },
  {
    name: "multi-downloader",
    path: "/multi-downloader",
    component: () => import("/opt/buildhome/repo/pages/multi-downloader.vue")
  },
  {
    name: "plans",
    path: "/plans",
    component: () => import("/opt/buildhome/repo/pages/plans.vue")
  },
  {
    name: "playlist-downloader",
    path: "/playlist-downloader",
    component: () => import("/opt/buildhome/repo/pages/playlist-downloader.vue")
  },
  {
    name: "preference",
    path: "/preference",
    component: () => import("/opt/buildhome/repo/pages/preference.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacy69l1Gm1VSzMeta || {},
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "profile-update",
    path: "/profile/update",
    meta: updateqDcvL67VWnMeta || {},
    component: () => import("/opt/buildhome/repo/pages/profile/update.vue")
  },
  {
    name: "region-checker",
    path: "/region-checker",
    component: () => import("/opt/buildhome/repo/pages/region-checker.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings4cDYwTsA31Meta || {},
    component: () => import("/opt/buildhome/repo/pages/settings.vue")
  },
  {
    name: "subtitle-summary",
    path: "/subtitle-summary",
    component: () => import("/opt/buildhome/repo/pages/subtitle-summary.vue")
  },
  {
    name: "subtitle-tasks",
    path: "/subtitle-tasks",
    component: () => import("/opt/buildhome/repo/pages/subtitle-tasks.vue")
  },
  {
    name: "subtitle-translator",
    path: "/subtitle-translator",
    component: () => import("/opt/buildhome/repo/pages/subtitle-translator.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsjw1825O2ZdMeta || {},
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "tools",
    path: "/tools",
    component: () => import("/opt/buildhome/repo/pages/tools.vue")
  },
  {
    name: "usage-history",
    path: "/usage-history",
    component: () => import("/opt/buildhome/repo/pages/usage-history.vue")
  },
  {
    name: "video-audio-to-summary",
    path: "/video-audio-to-summary",
    component: () => import("/opt/buildhome/repo/pages/video-audio-to-summary.vue")
  },
  {
    name: "video-to-subtitle",
    path: "/video-to-subtitle",
    component: () => import("/opt/buildhome/repo/pages/video-to-subtitle.vue")
  },
  {
    name: "youtube-tools",
    path: "/youtube-tools",
    component: () => import("/opt/buildhome/repo/pages/youtube-tools.vue")
  },
  {
    name: "downloader-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/downloader",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/downloader.vue")
  },
  {
    name: "extension-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/extension",
    meta: { ...(extensionODXOSAMnqoMeta || {}), ...{"seoLang":true} },
    component: () => import("/opt/buildhome/repo/pages/extension.vue")
  },
  {
    name: "hardsub-to-subtitle-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/hardsub-to-subtitle",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/hardsub-to-subtitle.vue")
  },
  {
    name: "index-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)",
    meta: { ...(indexniDiYCWjuTMeta || {}), ...{"seoLang":true} },
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "multi-downloader-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/multi-downloader",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/multi-downloader.vue")
  },
  {
    name: "playlist-downloader-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/playlist-downloader",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/playlist-downloader.vue")
  },
  {
    name: "region-checker-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/region-checker",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/region-checker.vue")
  },
  {
    name: "subtitle-summary-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/subtitle-summary",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/subtitle-summary.vue")
  },
  {
    name: "subtitle-translator-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/subtitle-translator",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/subtitle-translator.vue")
  },
  {
    name: "video-audio-to-summary-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/video-audio-to-summary",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/video-audio-to-summary.vue")
  },
  {
    name: "video-to-subtitle-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/video-to-subtitle",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/video-to-subtitle.vue")
  },
  {
    name: "youtube-tools-lang",
    path: "/:lang(es|zh|hi|ar|fr|pt|ja|de|vi|ko|ru|it|tr|id|th|bn|pl|nl|uk|ur|my|fa|he|ms|fil|ta|sw|ro|el|cs|hu|sv|fi|km|ne)/youtube-tools",
    meta: {"seoLang":true},
    component: () => import("/opt/buildhome/repo/pages/youtube-tools.vue")
  }
]